export default __webpack_public_path__ + "static/media/CommentThreeThree.5c806101.svg";